import React from 'react';
import { motion } from 'framer-motion';
import { MoveRight } from 'lucide-react';

const ResearchSection = () => {
  return (
    <section className="relative bg-white py-20 lg:py-0 border border-y-black">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Section - Abstract Background with Text */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            {/* Abstract Background with Colorful Lines */}
            <div className="relative w-full h-96 lg:h-[500px] rounded-r-3xl overflow-hidden">
              {/* Background Image */}
              <div 
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: 'url(/images/research.png)' }}
              />
              
              {/* Overlay Text */}
              <div className="absolute inset-0 flex flex-col justify-center p-8">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  viewport={{ once: true }}
                  className="text-white max-w-xxl mx-auto"
                >
                  <p className="text-sm font-semibold uppercase tracking-wider mb-4 font-sans">
                    RESEARCH AND INCUBATION
                  </p>
                  <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-semibold leading-tight font-source italic">
                    Inside Our
                    <br />
                    Research Lab
                  </h2>
                </motion.div>
              </div>
            </div>
          </motion.div>

          {/* Right Section - Text and Button */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-8 max-w-lg me-auto"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <p className="text-lg text-[#2B2B2B] leading-relaxed font-sans">
                Dive into the heart of innovation. Our researchers publish white-papers, 
                run longitudinal studies and refine every tool, so you benefit from the 
                latest in cognitive science.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <button className="bg-lime-400 hover:bg-lime-500 text-black font-semibold py-4 px-8 rounded-lg transition-colors duration-200 flex items-center space-x-2 group font-sans">
                <span>Visit the Research Library</span>
                <MoveRight className="w-8 h-8 text-black group-hover:translate-x-1 transition-transform duration-200 font-source font-regular" />
              </button>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ResearchSection;
